import { ReportParametersDto } from "./reportDto";

export interface EDIShippingNotesByPartReportDto extends ReportParametersDto {
	endDate: Date;
	partId: number;
	startDate: Date;
}

export class EDIShippingNotesByPartReportDto implements EDIShippingNotesByPartReportDto {
	constructor(data?: Partial<EDIShippingNotesByPartReportDto>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}